import { initializeApp } from 'firebase/app';
import { initializeFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBCwMxLZQh97vni-nwhCV7wson6qLcqxl4",
  authDomain: "huitest-9eb37.firebaseapp.com",
  projectId: "huitest-9eb37",
  storageBucket: "huitest-9eb37.firebasestorage.app",
  messagingSenderId: "25064612799",
  appId: "1:25064612799:web:ed504c328400b749b7370a",
  measurementId: "G-4R7SPLGJTR",
  databaseURL: "",
};
// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

// Initialize Firestore with settings
const db = initializeFirestore(app, {
  experimentalForceLongPolling: true,
});

const storage = getStorage(app);

export { auth, db, storage };
